module.exports = __webpack_public_path__ + "static/img_1682-79ba76cef90861bdb6ae885c703c93dc.jpg";